export default "__VITE_ASSET__Dwu5K5j8__"